import { identity } from 'lodash';
import Handsontable from 'handsontable';
import { createDeepSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { CellSelections } from '../../../../../common/table/TableTypes';
import { LegacyActiveHotTableSelector } from '../legacyHotTableStoreHooks';
import { getHotTableCellBackgroundColor } from '../../utils/hotInstanceUtils/hotTableCellMetaUtils';

export const selectLegacyActiveTableCellSelection = createDeepSelector<
    Handsontable | undefined,
    unknown,
    CellSelections | undefined
>(
    // It's important that we get the selection state here, rather than in the return function, otherwise
    //  if we just pass through the activeTableState, the selector will not re-run, because the table instance reference
    //  is stable.
    (activeTableState) => activeTableState?.getSelected(),
    identity,
);

/**
 * Get the background colour of the current cell selection.
 */
export const selectLegacyActiveTableCurrentCellBackgroundColor: LegacyActiveHotTableSelector<
    string | null | undefined
> = (activeHotTableInstance) => {
    const currentSelection = selectLegacyActiveTableCellSelection(activeHotTableInstance);
    return getHotTableCellBackgroundColor(activeHotTableInstance, currentSelection);
};
